import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    CatalogResponse,
    CatalogProductType,
    CatalogProductOperationResponse,
    CatalogUpdateRequest,
    CatalogProductCreateRequest,
    CatalogProductFieldUpdateRequest,
    CatalogProductDeleteRequest,
    CatalogProductDuplicateRequest,
    CatalogProductPasteRequest,
    BulkPublishResponse,
} from "src/api-service";
import { AppError } from "../../app-store-error.types";
import { CatalogLayout, CatalogDensity } from "./catalog.state";

// **************************************************************************
// CATALOG ACTIONS
// **************************************************************************
export const CatalogActions = createActionGroup({
    source: "Catalog",
    events: {
        // *** LOAD CATALOG (select and load full details) ***
        "Load Catalog": props<{ catalogId: number; financingCompanyId?: number }>(),
        "Load Catalog Success": props<{ catalog: CatalogResponse }>(),
        "Load Catalog Failure": props<{ error: AppError; toastKey: string }>(),

        // *** UPDATE CATALOG SETTINGS ***
        "Update Catalog": props<{ id?: number; request: CatalogUpdateRequest }>(),
        "Update Catalog Success": props<{ catalog: CatalogResponse; toastKey: string }>(),
        "Update Catalog Failure": props<{ error: AppError; toastKey: string }>(),

        // *** TOGGLE LOCK CUSTOMER PRICES ***
        "Toggle Lock Customer Prices": props<{ lockCustomerPrices: boolean }>(),
        "Toggle Lock Customer Prices Success": props<{ catalog: CatalogResponse; toastKey: string }>(),
        "Toggle Lock Customer Prices Failure": props<{ error: AppError; toastKey: string }>(),

        // *** TOGGLE INCLUDE CUSTOMER PRICE DECIMALS ***
        "Toggle Include Customer Price Decimals": props<{ includeDecimals: boolean }>(),
        "Toggle Include Customer Price Decimals Success": props<{ catalog: CatalogResponse; toastKey: string }>(),
        "Toggle Include Customer Price Decimals Failure": props<{ error: AppError; toastKey: string }>(),

        // *** PRODUCT OPERATIONS ***
        "Create Entity": props<{ request: CatalogProductCreateRequest }>(),
        "Create Entity Success": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),
        "Create Entity Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        "Update Entity Field": props<{ request: CatalogProductFieldUpdateRequest }>(),
        "Update Entity Field Success": props<{ response: CatalogProductOperationResponse; toastKey?: string }>(),
        "Update Entity Field Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        "Delete Entity": props<{ request: CatalogProductDeleteRequest }>(),
        "Delete Entity Success": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),
        "Delete Entity Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        "Upload Entity Image": props<{ entityType: CatalogProductType; entityId: number; file: File }>(),
        "Upload Entity Image Success": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),
        "Upload Entity Image Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        // *** DUPLICATE ***
        "Duplicate Entity": props<{ request: CatalogProductDuplicateRequest }>(),
        "Duplicate Entity Success": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),
        "Duplicate Entity Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        // *** PASTE ***
        "Paste Entity": props<{ request: CatalogProductPasteRequest }>(),
        "Paste Entity Success": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),
        "Paste Entity Failure": props<{ response: CatalogProductOperationResponse; toastKey: string }>(),

        // *** BULK PUBLISH/UNPUBLISH ALL PRODUCTS ***
        "Bulk Publish Products": props<{ publish: boolean }>(),
        "Bulk Publish Products Success": props<{ response: BulkPublishResponse; toastKey: string }>(),
        "Bulk Publish Products Failure": props<{ error: AppError; toastKey: string }>(),

        // *** RESET ***
        "Reset State": emptyProps(),

        // *** UI SETTINGS ***
        "Set Layout": props<{ layout: CatalogLayout }>(),
        "Set Density": props<{ density: CatalogDensity }>(),
    },
});
